import { NumericParameter } from '@drivingdoc/shared-types/reports';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { Controller, useFormContext } from 'react-hook-form';

interface NumericParameterFieldProps {
  parameter: NumericParameter;
}

export default function NumericParameterField({ parameter }: NumericParameterFieldProps) {
  const { control } = useFormContext();
  const { config } = parameter;
  // Calculate step based on decimalPlaces if step not explicitly set
  const step = config?.step ?? (config?.decimalPlaces ? Math.pow(10, -config.decimalPlaces) : 1);

  return (
    <Grid size={12}>
      <Controller
        name={parameter.name}
        control={control}
        defaultValue={config?.defaultValue ?? null}
        render={({ field, fieldState }) => {
          // Format display value with decimalPlaces if specified
          const displayValue =
            field.value != null && config?.decimalPlaces != null
              ? Number(field.value).toFixed(config.decimalPlaces)
              : (field.value ?? '');

          return (
            <TextField
              {...field}
              value={displayValue}
              fullWidth
              type="number"
              label={parameter.label}
              required={parameter.required}
              error={!!fieldState.error}
              helperText={fieldState.error?.message ?? parameter.helpText}
              slotProps={{
                input: {
                  startAdornment:
                    config?.unit && config.unitPosition === 'prefix' ? (
                      <InputAdornment position="start">{config.unit}</InputAdornment>
                    ) : undefined,
                  endAdornment:
                    config?.unit && config.unitPosition === 'suffix' ? (
                      <InputAdornment position="end">{config.unit}</InputAdornment>
                    ) : undefined,
                },
                htmlInput: {
                  min: config?.min,
                  max: config?.max,
                  step,
                },
              }}
              onChange={(e) => {
                const value = e.target.value === '' ? null : Number(e.target.value);
                field.onChange(value);
              }}
            />
          );
        }}
      />
    </Grid>
  );
}
